import { _fetch as fetchSecure } from '@hobs/utils/fetch';
import {
  FORSUBMIT,
  CREATE,
  UPDATE,
  REMOVE
} from '@hobs/constants/customServiceRequests';

export function update(data) {
  return dispatch => {
    dispatch(request());
    return fetchSecure(`CustomServiceRequests/${data.serviceRequestId}`, {
      body: data,
      method: 'PUT'
    })
      .then(response => {
        if (response.status === 200) {
          dispatch(success());

          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          const data = {
            status: response.status,
            payload: response.payload
          };
          return { success: false, ...data };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: UPDATE.REQUEST };
  }

  function success() {
    return { type: UPDATE.SUCCESS };
  }
  function failure(error) {
    return { type: UPDATE.FAILURE, error };
  }
}

export function forSubmit() {
  return dispatch => {
    dispatch(request());

    return fetchSecure('CustomServiceRequests/ForSubmit')
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));

          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          const data = {
            status: response.status,
            payload: JSON.parse(response.response)
          };
          return { success: false, ...data };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: FORSUBMIT.REQUEST };
  }
  function success(results) {
    return { type: FORSUBMIT.SUCCESS, results };
  }
  function failure(error) {
    return { type: FORSUBMIT.FAILURE, error };
  }
}

export function create(data) {
  return dispatch => {
    dispatch(request());
    return fetchSecure('CustomServiceRequests', { body: data, method: 'POST' })
      .then(response => {
        if (response.status === 200) {
          dispatch(success());
          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          const data = {
            status: response.status,
            payload: response.payload
          };
          return { success: false, ...data };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: CREATE.REQUEST };
  }
  function success() {
    return { type: CREATE.SUCCESS };
  }
  function failure(error) {
    return { type: CREATE.FAILURE, error };
  }
}

export function remove(serviceRequestId) {
  return dispatch => {
    dispatch(request());
    return fetchSecure(
      `StatementOfRequirements/ServiceRequests/${serviceRequestId}`,
      { method: 'DELETE' }
    )
      .then(response => {
        if (response.status === 200) {
          dispatch(success());

          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          const data = {
            status: response.status,
            payload: response.payload
          };
          return { success: false, ...data };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: REMOVE.REQUEST };
  }
  function success() {
    return { type: REMOVE.SUCCESS };
  }
  function failure(error) {
    return { type: REMOVE.FAILURE, error };
  }
}
